<template>
    <div class="box">
        <div class="v_header flexCenter" ref="getheight">
            <span class="headline">用户管理</span>
            <el-button class="input_button" size="mini" @click="getExport">导出</el-button>
        </div>
        <div class="flexCenter mb16" ref="getheight1">
            <div class="flexCenter">
                <div
                    v-for="(item, index) of options"
                    @click="getStatus(item.value)"
                    :key="index"
                    class="u_status flexCenter"
                    :class="page.status == item.value ? 'active' : ''"
                >
                    <span class="label">{{ item.label }}</span>
                    <div v-if="message != [] && page.status == item.value" class="dot mr24">
                        {{ page.total > 99 ? '99+' : page.total }}
                    </div>
                    <div v-else class="mr24"></div>
                </div>
            </div>
            <el-input clearable @change="changeSearch_name" v-model="Search_name" placeholder="请输入医院名称或用户姓名"> </el-input>
        </div>
        <el-table :data="message" :max-height="height + 'px'" style="width: 100%">
            <el-table-column fixed label="提交时间" width="150" :render-header="renderPrice">
                <template slot-scope="scope">
                    {{ scope.row.created_on | formatOrdertime }}
                </template>
            </el-table-column>
            <el-table-column label="姓名/手机号" :render-header="renderPrice" width="180">
                <template slot-scope="scope">
                    <el-tooltip class="item" effect="dark" :content="scope.row.name + scope.row.phone_number" placement="bottom">
                        <div>
                            {{ scope.row.name }}
                            <div>{{ scope.row.phone_number }}</div>
                        </div>
                    </el-tooltip>
                </template>
            </el-table-column>
            <el-table-column label="所属医院" min-width="180" :render-header="renderPrice">
                <template slot-scope="scope">
                    <el-tooltip class="item" effect="dark" :content="scope.row.hospital_name" placement="bottom">
                        <span class="v_tips">{{ scope.row.hospital_name }} </span>
                    </el-tooltip>
                </template>
            </el-table-column>
            <el-table-column label="医院地址" min-width="180" :render-header="renderPrice">
                <template slot-scope="scope">
                    <el-tooltip
                        class="item"
                        effect="dark"
                        :content="
                            scope.row.province_info.name +
                            scope.row.city_info.name +
                            scope.row.district_info.name +
                            scope.row.hospital_position_detail
                        "
                        placement="bottom"
                    >
                        <span class="v_tips"
                            >{{ scope.row.province_info.name }} {{ scope.row.city_info.name }} {{ scope.row.district_info.name
                            }}{{ scope.row.hospital_position_detail }}</span
                        >
                    </el-tooltip>
                </template>
            </el-table-column>
            <el-table-column label="微信定位" min-width="180" :render-header="renderPrice">
                <template slot-scope="scope">
                    <el-tooltip
                        class="item"
                        effect="dark"
                        :content="
                            scope.row.wechat_province_name +
                            scope.row.wechat_city_name +
                            scope.row.wechat_district_name +
                            scope.row.wechat_position_detail
                        "
                        placement="bottom"
                    >
                        <span class="v_tips"
                            >{{ scope.row.wechat_province_name }} {{ scope.row.wechat_city_name }} {{ scope.row.wechat_district_name }}
                            {{ scope.row.wechat_position_detail }}
                        </span>
                    </el-tooltip>
                </template>
            </el-table-column>
            <el-table-column label="奖励码/产品" min-width="180" :render-header="renderPrice">
                <template slot-scope="scope">
                    <el-tooltip
                        class="item"
                        effect="dark"
                        :content="
                            scope.row.red_envelope_label + scope.row.product_info.product_name + scope.row.product_info.product_number
                        "
                        placement="bottom"
                    >
                        <span class="v_tips"
                            >{{ scope.row.red_envelope_label }} {{ scope.row.product_info.product_name }}&{{
                                scope.row.product_info.product_number
                            }}</span
                        >
                    </el-tooltip>
                </template>
            </el-table-column>
            <el-table-column label="状态" width="100">
                <template slot-scope="scope">
                    <el-tag :type="scope.row.status | client_user_status_type">{{ scope.row.status | client_user_status_list }}</el-tag>
                </template>
            </el-table-column>
            <el-table-column label="备注" min-width="150">
                <template slot-scope="scope">
                    <el-tooltip class="item" effect="dark" :content="scope.row.remarks" placement="bottom">
                        <span class="v_tips">{{ scope.row.remarks }}</span>
                    </el-tooltip>
                </template>
            </el-table-column>
            <el-table-column label="操作" width="180" fixed="right">
                <template slot-scope="scope">
                    <div class="flexdown">
                        <div class="mb10" v-if="scope.row.status != 'passed' && scope.row.status != 'failed' && scope.row.status != 'ban'">
                            <el-button type="primary" size="mini" @click="getClick(scope, 'success')">通过</el-button>
                            <el-button type="info" size="mini" @click="getClick(scope, 'err')">拒绝</el-button>
                        </div>
                        <div>
                            <el-button type="primary" size="mini" @click="getClick(scope, 'edit')">编辑</el-button>
                            <el-button type="info" size="mini" @click="getClick(scope, 'remarks')">备注</el-button>
                        </div>
                        <el-button
                            class="mt10"
                            v-if="scope.row.status == 'passed' || scope.row.status == 'failed' || scope.row.status == 'ban'"
                            type="warning"
                            size="mini"
                            @click="getClick(scope, 'status')"
                            >调整用户分类</el-button
                        >
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <el-dialog
            :title="type == 'edit' ? '用户信息' : '' || type == 'status' ? '调整用户分类' : '' || type == 'remarks' ? '备注信息' : ''"
            :visible.sync="resetDialogVisible"
            width="648px"
            top="15vh"
            class="v_dol"
        >
            <el-form :model="row">
                <div v-if="type == 'edit'">
                    <!-- <el-form-item label="审核人员id">
                        <el-input v-model="row.user_id" size="mini" clearable placeholder="输入审核人员id"></el-input>
                    </el-form-item> -->
                    <el-form-item label="姓名">
                        <el-input v-model="row.name" size="mini" clearable placeholder="输入姓名"></el-input>
                    </el-form-item>
                   
                    <el-form-item label="医院">
                        <el-input v-model="row.hospital_name" size="mini" clearable placeholder="输入医院名称"></el-input>
                    </el-form-item>
                    <el-form-item label="医院地址" class="u_cascader">
                        <el-cascader
                            ref="areas"
                            :props="regionParams"
                            v-model="value"
                            :options="area"
                            @change="handleChange"
                            size="mini"
                        ></el-cascader>
                        <el-input
                            class="mt8"
                            v-model="row.hospital_position_detail"
                            size="mini"
                            clearable
                            placeholder="输入医院详细地址"
                        ></el-input>
                    </el-form-item>
                </div>
                <el-input
                    v-if="type == 'remarks'"
                    class="el_input"
                    v-model="row.remarks"
                    :autosize="{ minRows: 4, maxRows: 8 }"
                    type="textarea"
                    clearable
                    placeholder="输入备注"
                ></el-input>
                <div v-if="type == 'status'">
                    <el-form-item>
                        <el-select v-model="row.status" placeholder="请选择" size="mini">
                            <el-option v-for="item in options1" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                        </el-select>
                    </el-form-item>
                    <div class="test">确认该操作将影响此用户后续扫码领取奖励，请谨慎选择</div>
                </div>
            </el-form>
            <div class="dialog-footer">
                <!-- <el-button size="mini" @click="resetDialogFalse">取 消</el-button> -->
                <el-button class="v_buttons" @click="resetDialogTrue">保存</el-button>
            </div>
        </el-dialog>
        <div class="notificationn" v-if="notificationns">
            <div class="notificationn_left"></div>
            <div>
                <div class="notificationn_title" v-if="msg">{{ msg }}</div>
            </div>
        </div>
        <pagination :page="page" @getPage="getPage" @getNum="getNum"></pagination>
    </div>
</template>

<script>
import * as XLSX from 'xlsx';
export default {
    name: 'binding',
    data() {
        return {
            notificationns: false,
            msg: '',
            page: {
                num:10,
                page: 1,
                total: 0,
                search_user_name: '',
                search_hospital_name: '',
                status: 'wait_audit'
            },
            options: [
                {
                    value: 'wait_audit',
                    label: '待审核'
                },
                {
                    value: 'passed',
                    label: '审核成功'
                },
                {
                    value: 'failed',
                    label: '审核失败'
                },
                {
                    value: 'ban',
                    label: '黑名单'
                }
            ],
            options1: [
                {
                    value: 'passed',
                    label: '审核成功'
                },
                {
                    value: 'failed',
                    label: '审核失败'
                },
                {
                    value: 'ban',
                    label: '黑名单'
                }
            ],
            area: [],
            array: [],
            value: [],
            regionParams: {
                lazy: true, //	是否动态加载子节点，需与 lazyLoad 方法结合使用
                lazyLoad: this.handleGetClassOrStudent //懒加载调用的方法
            },
            message: [],
            row: {
                province_info: {},
                city_info: {},
                district_info: {}
            },
            index: -1,
            type: '',
            resetDialogVisible: false,
            height: '',
            Search_name: '',
            children: []
        };
    },
    mounted() {
        window.screenHeight = document.body.clientHeight;
        this.screenHeight = window.screenHeight;
        this.height = this.screenHeight - this.$refs.getheight.offsetHeight - this.$refs.getheight1.offsetHeight - 85 - 24 - 16 - 40;
        this.getMessage(); //获取列表
       
    },
    methods: {
        renderPrice(h, { column, $index }) {
            const styleFilter = {
                fontSize: '16px',
                fontWeight: 'bold',
                marginLeft: '8px'
            };
            return [
                column.label,
                h(
                    'i',
                    [
                        h('span', {
                            class: { 'el-icon-bottom': true },
                            style: {
                                ...styleFilter //设置样式
                            }
                        })
                    ] // 图标
                )
            ];
        },
        // 动态加载级联
        handleGetClassOrStudent(node, resolve) {
            let that = this;
            const { data } = node; //等同于const data = node.data
            if (data) {
                //上面的代码自行补充
                this.$nextTick((_) => {
                    var node = this.$refs.areas.getCheckedNodes(); //获取当前选中节点
                    if (node && node[0] && node[0].pathNodes) {
                        //选中节点的所有父节点
                        for (var i = 0; i < node[0].pathNodes.length; i++) {
                            node[0].pathNodes[i].loaded = true; //节点的加载状态设为true，就不会再加载了
                        }
                    }
                });
                console.log('data.province_id, city_id: data.id :>> ', data);
                if (data.province_id) {
                    that.$get('/backapi/area', { province_id: data.province_id, city_id: data.id }).then(function (res1) {
                        let children = res1.data;
                        children.map((item) => {
                            (item.value = item.id), (item.label = item.name), (item.leaf = true);
                        });
                        console.log('children :>> ', children);
                        if (children.length != 0) {
                            for (let i = 0; i < that.array.length; i++) {
                                for (let j = 0; j < that.array[i].children.length; j++) {
                                    if (that.array[i].children[j].id == data.id) {
                                        that.array[i].children[j].children = children;
                                        that.value = [data.province_id, data.id, that.row.district_info.id];
                                        that.area = that.array;
                                        resolve(children);
                                    }
                                }
                            }
                        } else {
                            for (let i = 0; i < that.array.length; i++) {
                                for (let j = 0; j < that.array[i].children.length; j++) {
                                    if (that.array[i].children[j].id == data.id) {
                                        that.array[i].children[j].leaf = true;
                                        that.value = [ data.province_id,  data.id];
                                             that.area = that.array;
                                        resolve([]);

                                    }
                                }
                            }
                           
                        }
                    });
                } else {
                    that.$get('/backapi/area', { province_id: data.id }).then(function (res1) {
                        let children = res1.data;
                        children.map((item) => {
                            (item.value = item.id), (item.label = item.name);
                        });
                        for (let i = 0; i < that.array.length; i++) {
                            if (that.array[i].id == data.id) {
                                that.array[i].children = children;
                                resolve(children);
                            } else {
                                that.array[i].children = [];
                                resolve([]);
                            }
                        }
                    });
                }

                // that.$get('/backapi/area', { province_id: data.province_id, city_id: data.id }).then(function (res1) {
                //     let children = res1.data;
                //     if (res1.data.length != 0) {
                //         children.map((item) => {
                //             (item.value = item.id), (item.label = item.name), (item.leaf = true);
                //         });
                //         resolve(children);
                //     } else {
                //         resolve([]);
                //     }
                // });
            }
        },
        async getMessage() {
            let that = this;
            let obj = {
                page: that.page.page,
                num: that.page.num,
                search_hospital_name: that.page.search_hospital_name,
                search_user_name: that.page.search_user_name,
                status: that.page.status
            };
            const res = await that.$get('/backapi/client_user', obj);
            
            if (res.count) {
                console.log(  res);
                that.page.total = res.count
                that.message = res.data
              
            } else {
                that.page.total = 0;
                that.message = [];
            }
            // let that = this;
        that.$get('/backapi/area').then(function (res1) {
            let children = res1.data;
            children.map((item) => {
                (item.value = item.id), (item.label = item.name);
            });
            // console.log('children :>> ', children);
            that.array = children;
            
        });
            // that.$get('/backapi/client_user', obj).then(function (res) {
            //     if (res.count) {
            //         that.page.total = res.count;
            //         that.message = res.data;
            //     } else {
            //         that.page.total = 0;
            //         that.message = [];
            //     }
            // });
        },
        getPage(e) {
            this.page.page = e;
            this.getMessage();
        },
        getNum(e) {
            this.page.num = e;
            this.page.page = 1;
            this.getMessage();
        },
        // 状态
        getStatus(e) {
            this.page.status = e;
            this.getMessage(); //获取列表
        },
        // 搜索用户
        async changeSearch_name(e) {
            let that = this;
            that.Search_name = e;
            let obj = {
                page: 1,
                num: 10,
                search_user_name: e,
                status: that.page.status
            };
            const res = await that.$get('/backapi/client_user', obj);
            if (res.count) {
                that.page.total = res.count;
                that.message = res.data;
            } else {
                let obj1 = {
                    page: 1,
                    num: 10,
                    search_hospital_name: e,
                    status: that.page.status
                };
                const res1 = await that.$get('/backapi/client_user', obj1);
                if (res1.count) {
                    that.page.total = res1.count;
                    that.message = res1.data;
                } else {
                    that.page.total = 0;
                    that.message = [];
                }
            }
            // this.getMessage();
        },
        //医院
        // changeSearch_hospital(e) {
        //     if (e) {
        //         this.page.search_hospital_name = e;
        //         this.page.num = this.page.total;
        //         this.page.page = 1;
        //     } else {
        //         this.page.num = 10;
        //         this.page.page = 1;
        //     }
        //     this.getMessage(); //获取列表
        // },
        // 导出
        getExport() {
            let that = this;
            if (that.page.total == 0) {
                // that.$message({
                //     message: '暂无数据导出',
                //     type: 'warning'
                // });
                that.msg = '暂无数据导出';
                that.notificationns = true;
                setTimeout(() => {
                    that.notificationns = false;
                }, 3000);
                return;
            }
            let obj = {
                page:that.page.page,
                is_download:true,
                num: that.page.total,
                status: that.page.status
            };
            that.$get('/backapi/client_user', obj)
                .then(function (res) {
                    if (res.code == 200) {
                        that.msg = '数据导出成功';
                        that.notificationns = true;
                        setTimeout(() => {
                            that.notificationns = false;
                        }, 3000);
                    } else {
                        (that.msg = '导出失败'), (that.notificationns = true);
                        setTimeout(() => {
                            that.notificationns = false;
                        }, 3000);
                    }
                })
                .catch((reject) => {
                    (that.msg = '导出失败'), (that.notificationns = true);
                    setTimeout(() => {
                        that.notificationns = false;
                    }, 3000);
                });
            //     if (res.count) {
            //         if (res.data.length != 0 && res.data) {
            //             const fdArray = [];
            //             res.data.forEach(function (item, index) {
            //                 var obj = {
            //                     提交时间: that.$formatOrdertime(item.created_on),
            //                     姓名手机号: item.name + item.phone_number,
            //                     所属医院: item.hospital_name, //
            //                     医院地址:
            //                         item.province_info.name + item.city_info.name + item.district_info.name + item.hospital_position_detail,
            //                     微信定位:
            //                         item.wechat_province_name +
            //                         item.wechat_city_name +
            //                         item.wechat_district_name +
            //                         item.wechat_position_detail,

            //                     奖励码产品: item.red_envelope_label + item.product_info.product_name + item.product_info.product_number,
            //                     状态: that.$client_user_status_list(item.status),
            //                     备注: item.remarks
            //                 };
            //                 fdArray.push(obj);
            //             });
            //             var wb = XLSX.utils.book_new();
            //             let sheet = XLSX.utils.json_to_sheet(fdArray);
            //             sheet['!cols'] = [
            //                 { wch: 20 },
            //                 { wch: 20 },
            //                 { wch: 30 },
            //                 { wch: 40 },
            //                 { wch: 40 },
            //                 { wch: 40 },
            //                 { wch: 40 },
            //                 { wch: 10 },
            //                 { wch: 40 }
            //             ];
            //             XLSX.utils.book_append_sheet(wb, sheet, 'sheet', { raw: true });
            //             XLSX.writeFile(wb, '用户管理 - 数据列表' + '.xlsx');
            //             that.msg = '数据导出成功';
            //             that.notificationns = true;
            //             setTimeout(() => {
            //                 that.notificationns = false;
            //             }, 3000);
            //         } else {
            //             // that.$message({
            //             //     message: '暂无数据导出',
            //             //     type: 'warning'
            //             // });
            //             that.msg = '暂无数据导出';
            //             that.notificationns = true;
            //             setTimeout(() => {
            //                 that.notificationns = false;
            //             }, 3000);
            //         }
            //     } else {
            //         // that.$message({
            //         //     message: '暂无数据导出',
            //         //     type: 'warning'
            //         // });
            //         that.msg = '暂无数据导出';
            //         that.notificationns = true;
            //         setTimeout(() => {
            //             that.notificationns = false;
            //         }, 3000);
            //     }
            // });
        },
        // 操作按钮
        getClick(e, type) {
            this.type = '';
            this.type = type;
            this.index = e.$index;
            this.row = JSON.parse(JSON.stringify(e.row));
            if (type == 'edit') {
                // let array = [];
                // array.push({ value: this.row.province_info.id, label: this.row.province_info.name });
                // this.array = array;
                console.log('this.row :>> ', this.row);
                this.value = [this.row.province_info.id, this.row.city_info.id, this.row.district_info.id ];
                // console.log(this.row.province_info.id);
                this.getpID1(this.row.province_info.id, this.row.city_info.id);
            } else if (type == 'status') {
                this.resetDialogVisible = true;
            } else if (type == 'remarks') {
                this.resetDialogVisible = true;
            } else if (type == 'err') {
                let that = this;
                that.$confirm('确定要拒绝吗, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
                    .then(() => {
                        that.resetDialogTrue();
                    })
                    .catch(() => {
                        that.$message({
                            type: 'info',
                            message: '已取消操作'
                        });
                    });
            } else if (type == 'success') {
                let that = this;
                that.$confirm('确定要通过吗, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
                    .then(() => {
                        that.resetDialogTrue();
                    })
                    .catch(() => {
                        that.$message({
                            type: 'info',
                            message: '已取消操作'
                        });
                    });
            }
        },
        getpID1(province_id, city_id) {
            let that = this;
            that.$get('/backapi/area', { province_id: province_id }).then(function (res1) {
                let children = res1.data;
                // console.log('children :>> ', children);
                children.map((item) => {
                    (item.value = item.id), (item.label = item.name);
                });
                for (let i = 0; i < that.array.length; i++) {
                    if (that.array[i].id == province_id) {
                        that.array[i].children = children;
                    } else {
                        that.array[i].children = [];
                    }
                }
                that.getCity_id(province_id, city_id);
            });
        },
        getCity_id(province_id, city_id) {
            let that = this;
            that.$get('/backapi/area', { province_id: province_id, city_id: city_id }).then(function (res1) {
                let children = res1.data;
                children.map((item) => {
                    (item.value = item.id), (item.label = item.name), (item.leaf = true);
                });
                if (children.length != 0) {
                    for (let i = 0; i < that.array.length; i++) {
                        // console.log('that.array[i].children :>> ', that.array[i].children);
                        for (let j = 0; j < that.array[i].children.length; j++) {
                            if (that.array[i].children[j].id == children[0].city_id) {
                                that.array[i].children[j].children = children;
                            }
                        }
                    }
                    that.value = [that.row.province_info.id, that.row.city_info.id, that.row.district_info.id];
                    that.area = that.array;
                } else {
                    for (let i = 0; i < that.array.length; i++) {
                        for (let j = 0; j < that.array[i].children.length; j++) {
                            if (that.array[i].children[j].id == city_id) {
                                that.array[i].children[j].leaf = true;
                            }
                        }
                    }
                    that.value = [that.row.province_info.id, that.row.city_info.id];
                    that.area = that.array;
                }
                // console.log('that.arra :>> ', that.array);
                that.resetDialogVisible = true;
            });
        },
        handleChange(e) {
            // console.log('e :>> ', e);
            this.value = e;
        },
        resetDialogFalse() {
            this.resetDialogVisible = false;
            this.index = -1;
            this.row = {};
            // this.array = [];
            this.area = [];
            this.value = [];
            // this.type = '';
        },
        resetDialogTrue() {
            let that = this;
            let obj = {
                id: that.row.id
            };
            if (this.type == 'remarks') {
                obj.remarks = that.row.remarks;
            }
            if (this.type == 'err') {
                obj.status = 'failed';
            }
            if (this.type == 'success') {
                obj.status = 'passed';
            }
            if (this.type == 'status') {
                obj.status = that.row.status;
            }
            if (this.type == 'edit') {
                (obj.name = that.row.name),
                // (obj.user_id = that.row.user_id),
                    (obj.hospital_name = that.row.hospital_name),
                    (obj.city_id = that.value[1]),
                    (obj.district_id = that.value[2]),
                    (obj.hospital_position_detail = that.row.hospital_position_detail);
            }
       
            that.$put('/backapi/client_user', obj).then(function (res) {
                if (res.code == 200) {
                  
                    that.msg = '修改成功';
                    that.notificationns = true;
                    setTimeout(() => {
                        that.notificationns = false;
                    }, 3000);
                    that.getMessage();
                    that.resetDialogFalse();
                } else {
                
                    that.msg = res.msg;
                    that.notificationns = true;
                    setTimeout(() => {
                        that.notificationns = false;
                    }, 3000);
                }
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.test {
    font-family: 'PingFang SC';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 140%;
    /* or 22px */

    color: #21272a;
}
/deep/.el-form-item__content.el-select {
    width: 100%;
}
/deep/.el-textarea__inner {
    height: 193px !important;
    font-family: 'PingFang SC';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 140%;

    color: #697077;
    border: 1px solid #f2f4f8;
    filter: drop-shadow(0px 1px 1px #c1c7cd);
    margin-bottom: 16px;
}

.mt8 {
    margin-top: 8px;
}
/deep/.el-form-item__content {
    width: 100%;
}
/deep/.u_cascader {
    display: flex;
    flex-direction: column;
    align-items: baseline;
}
.v_buttons {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 129px;
    height: 48px;
    background: #91d9f2;
    border: 2px solid #91d9f2;
    border-radius: 8px;
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    letter-spacing: 0.5px;
    color: #ffffff;
}

/deep/ .v_dol .el-dialog {
    background: #ffffff;
    padding: 24px;
    border: 1px solid #dde1e6;
    border-radius: 16px;
}

/deep/.v_dol .el-dialog .el-dialog__header {
    padding: 0;
    margin-bottom: 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
/deep/.v_dol .el-dialog__headerbtn {
    position: relative;
    top: 0;
    right: 0;
}
/deep/.v_dol .el-dialog__close {
    font-size: 18px;
    color: #21272a;
}
/deep/.v_dol .el-dialog__title {
    color: #21272a;
    font-family: 'PingFang SC';
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
}
/deep/.v_dol .el-dialog__body {
    padding: 0;
}
/deep/.v_dol .el-input__inner {
    height: 48px;
    padding: 12px 16px;
    border: 1px solid #f2f4f8;
    filter: drop-shadow(0px 1px 1px #c1c7cd);
    border-radius: 8px;
    font-weight: 400;
    font-size: 16px;
    color: #697077;
}

/deep/.flexCenter .el-input {
    width: 387px;
}
/deep/ el-input::-webkit-input-placeholder {
    font-family: 'PingFang SC';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    letter-spacing: 0.5px;
    color: #ababab;
}
/deep/.flexCenter .el-input .el-input__inner {
    background: #ffffff;
    border: 1px solid #16307c;
    border-radius: 4px;
    font-weight: 400;
    font-size: 16px;
    color: #121619;
    width: 100%;
    height: 35px;
    background: url('../../assets/img/search-outline.png') no-repeat 8px center;
    background-size: 24px;
    padding-left: 40px;
}
.mb16 {
    margin-bottom: 16px;
    justify-content: space-between;
}
.dot {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 18px;
    background: #16307c;
    border-radius: 9px;
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 140%;
    /* identical to box height, or 17px */

    text-align: center;

    /* Default/White */

    color: #ffffff;
    margin-left: 4px;
}
.mr24 {
    margin-right: 24px;
}
.u_status {
    font-family: 'PingFang SC';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 100%;
    letter-spacing: 0.5px;
    color: #21272a;
    cursor: pointer;
}
.active {
    color: #001d6c !important;
}
.v_header {
    justify-content: space-between;
    margin-bottom: 24px;
}
/deep/.el-table .el-table__cell {
    border: none;
}
/deep/.el-table thead {
    font-family: 'PingFang SC';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #121619;
}
/deep/.el-table {
    font-weight: 400;
    font-size: 12px;
    color: #121619;
}

.flexdown {
    display: flex;
    flex-direction: column;
    align-items: center;
}
.mb10 {
    margin-bottom: 10px;
}
.mt10 {
    margin-top: 10px;
}
</style>
